import { ReconciliationGroupTable } from "./ReconciliationGroupTable";
import {
  ReconciliationGroupsTableProvider,
  useReconciliationGroupsTable
} from "../../../context/ReconciliationGroupsTableContext";
import { Button, Card, CardProps, Space } from "antd";
import { CreateReconciliationModal } from "../CreateReconciliationModal";
import { ReconciliationGroup } from "../../../types/reconciliation";
import { SyncOutlined } from "@ant-design/icons";
import { useGetReconciliationGroupsQuery } from "../../../redux/api/reconciliationsApiSlice";


const RefreshReconciliationGroupButton = () => {
  const {getParamsForApiRequest} = useReconciliationGroupsTable();

  const {refetch} = useGetReconciliationGroupsQuery(getParamsForApiRequest());

  return (
    <Button type={"link"} icon={<SyncOutlined />} onClick={() => refetch()}>
      Aggiorna
    </Button>
  );
}

export const ReconciliationGroupTableCard = ({ onTableRowSelect, cardProps }: {
  onTableRowSelect?: (row: ReconciliationGroup) => void,
  cardProps?: CardProps
}) => {

  return (
    <ReconciliationGroupsTableProvider>
      <Card
        title={"Lista Broker"}
        extra={
          <Space direction={"horizontal"}>
            <RefreshReconciliationGroupButton/>
            <CreateReconciliationModal />
          </Space>
          }
        {...cardProps}>

        <ReconciliationGroupTable onRecordDetailClick={onTableRowSelect} />
      </Card>
    </ReconciliationGroupsTableProvider>
  );
};